const SkillItem = (props: any) => {
    const { name } = props
    return (
        <div className="bg-text-id px-1.5 py-1 rounded mr-2">
            <p className="text-on-primary-container text-sm	 font-normal">{`"${name}"`}</p>
        </div>
    )
}
export default SkillItem